import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PhoneIcon from '@material-ui/icons/Phone';

export default { IconButton, VisibilityIcon, PhoneIcon };
